export default __webpack_public_path__ + "b39a999ae01b41ac82d46241e762feb5.png";